import { createRoute, useNavigate, useParams } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { LiveJoinScreen } from "@/features/live/components/join-screen";

function LiveSessionPage() {
  const params = useParams({ from: "/u/$u/live/$sessionId" });
  const navigate = useNavigate();
  return (
    <LiveJoinScreen sessionId={params().sessionId} onBack={() => void navigate({ to: ".." })} />
  );
}

export const liveSessionRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/live/$sessionId",
  component: LiveSessionPage,
});
